import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MeetingDocumentModelDto } from '@shared/interfaces/dtos/meetings';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root',
})
export class PointDocumentsService extends BaseHttpService {
  protected endPoint: string = '';

  public fetchPointDocumentModels(pointId: number): Observable<MeetingDocumentModelDto[]> {
    return this.http.get<MeetingDocumentModelDto[]>(
      this.buildURL({ overrideEndPoint: `Points/${pointId}/ModelesDocuments` })
    );
  }

  public generatePointDocument(
    pointId: number,
    documentModelId: number,
    options?: { asPreview?: boolean; openAfterGeneration?: boolean }
  ): Observable<unknown> {
    const { asPreview = false, openAfterGeneration = false } = options || {};

    return this.http.post<unknown>(
      this.buildURL({ overrideEndPoint: `Points/${pointId}/ModelesDocuments/${documentModelId}/Generate` }),
      null,
      { params: { autoSave: !asPreview, openAfterGeneration } }
    );
  }

  public generatePointDocumentPreview(pointId: number, documentModelId: number): Observable<unknown> {
    return this.http.post<unknown>(
      this.buildURL({ overrideEndPoint: `Points/${pointId}/ModelesDocuments/${documentModelId}/PreviewRequests` }),
      null
    );
  }

  public downloadPointDocumentPDF(pointId: number, documentModelId: number): Observable<Blob> {
    return this.http.get<Blob>(
      this.buildURL({ overrideEndPoint: `Points/${pointId}/ModelesDocuments/${documentModelId}/DownloadPdf` }),
      { responseType: 'blob' as 'json' }
    );
  }

  public uploadPointDocumentRTF(config: { pointId: number; documentModelId: number; file: File }): Observable<unknown> {
    const formData = new FormData();
    formData.append('file', config.file);

    return this.http.post<unknown>(
      this.buildURL({
        overrideEndPoint: `Points/${config.pointId}/ModelesDocuments/${config.documentModelId}/UploadRtf`,
      }),
      formData
    );
  }

  public downloadPointDocumentRTF(pointId: number, documentModelId: number): Observable<Blob> {
    return this.http.get<Blob>(
      this.buildURL({ overrideEndPoint: `Points/${pointId}/ModelesDocuments/${documentModelId}/DownloadRtf` }),
      { responseType: 'blob' as 'json', params: { generatedAndSaved: true } }
    );
  }
}
